import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

let webConfigEnv = (<string>(<any>window).RIEnv).toUpperCase();

if (['PROD','PR50','PR51'].includes( webConfigEnv)) {
  environment.production = true;
}
if (['UAT','CT50'].includes( webConfigEnv)) {
  environment.enableCventmail = true;
}

if (environment.production || ['PROD','PR50','PR51','UAT','CT50'].includes( webConfigEnv)) {
  enableProdMode();
}
if((<any>window).RIHelpUrl){
  environment.helpUrl = (<any>window).RIHelpUrl;
}
if((<any>window).RIGoogleSearchURL){
  environment.googleMapUrl = (<any>window).RIGoogleSearchURL;
}
if((<any>window).PortalLoginPage){
  try {
    environment.PortalLoginPage  = (<any>window).PortalLoginPage;
  } catch (error) {
    console.log('error setting start '+ error)
  }
}

if((<any>window).GDPRMsgStart){
  try {
    environment.GDPRMsgStart = new Date( (<any>window).GDPRMsgStart);
  } catch (error) {
    console.log('error setting start '+ error)
  }
}
if((<any>window).GDPRMsgEnd){
try {
  environment.GDPRMsgEnd = new Date( (<any>window).GDPRMsgEnd);
} catch (error) {
  console.log('error setting stop '+ error)
}
}

console.log(environment.GDPRMsgStart.toISOString());
console.log(environment.GDPRMsgEnd.toISOString());

//these two methods to make this call do not result in the same code ¯\_(ツ)_/¯
//Open ticket https://github.com/angular/angular-cli/issues/8880
//const platform = platformBrowserDynamic();
//platform.bootstrapModule(AppModule)
platformBrowserDynamic().bootstrapModule(AppModule)
.then((l) =>{
    let scriptElem = document.createElement('script');
    scriptElem.src = environment.googleMapUrl;
    scriptElem.type = 'text/javascript';
    scriptElem.async = true;
    scriptElem.charset = 'utf-8';
    let head = document.getElementsByTagName('head')[0].appendChild(scriptElem);
  }
);

